var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var DocumentTypeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 70,
    glyphOffsetY: 3
  }), React.createElement("path", {
    d: "M33.5218 57.0435H8.47827V61.2174H33.5218V57.0435Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M21 25.7392C27.887 25.7392 33.5218 20.1044 33.5218 13.2174C33.5218 6.33046 27.887 0.695679 21 0.695679C14.1131 0.695679 8.47827 6.33046 8.47827 13.2174C8.47827 20.1044 14.1131 25.7392 21 25.7392ZM14.7391 11.1305L18.9131 15.3044L27.2609 6.95655L29.3478 9.0435L18.9131 19.4783L12.6522 13.2174L14.7391 11.1305Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M33.5218 65.3914H8.47827V69.5653H33.5218V65.3914Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M33.5218 48.6957H8.47827V52.8696H33.5218V48.6957Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M0.130371 44.5217V65.6C1.38255 66.4348 2.84341 67.2696 4.30428 67.8957V44.5217H12.6521V36.1739H37.6956V67.8957C39.1565 67.2696 40.6173 66.4348 41.8695 65.6V32H12.6521L0.130371 44.5217Z",
    fill: "black"
  }));
};
export var DocumentTypeIconGlyph = function (props) {
  return React.createElement(DocumentTypeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};